import { NotificationButton } from "../Buttons/NotificationButton";
import Dropdown from "../Dropdown/Dropdown";
import {
  useGetNotifications,
  useMarkNotificationAsRead,
} from "../../api/hooks";
import { NotificationItem } from "./NotificationItem";

export function NotificationMenu() {
  const {
    data: notifications = [],
  } = useGetNotifications();

  const { mutate: markAsRead } = useMarkNotificationAsRead();

  const handleNotificationClick = (notificationId) => {
    try {
      markAsRead(notificationId);
    } catch (err) {}
  };

  const hasUnread = notifications.some((n) => !n.read);

  const content = (
    <div className="min-w-[300px] min-h-[100px] p-4 flex items-center justify-center">
      {notifications.length === 0 ? (
        <p className="text-sm text-gray-500 text-center">
          You don’t have any notifications.
        </p>
      ) : (
        <ul className="space-y-2 w-full">
          {notifications.map((notif, idx) => (
            <NotificationItem
              notif={notif}
              key={idx}
              onClick={handleNotificationClick}
            />
          ))}
        </ul>
      )}
    </div>
  );
  return (
    <Dropdown
      button={<NotificationButton hasUnread={hasUnread} />}
      content={content}
      autoClose={false}
    />
  );
}
